import { render, staticRenderFns } from "./PostBar.vue?vue&type=template&id=302f09de&scoped=true"
import script from "./PostBar.vue?vue&type=script&lang=js"
export * from "./PostBar.vue?vue&type=script&lang=js"
import style0 from "./PostBar.vue?vue&type=style&index=0&id=302f09de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f09de",
  null
  
)

export default component.exports